export default {
  id: "settings",
  title: "Settings: Codes, Questions & More",
  section: "Administration",
  order: 90,
  keywords: "settings service codes non-service questions vr activities mileage ai email prompts archived low units alerts",
  body: `
## What it is

Settings is the configuration hub for the service catalog and the
clock-out experience. Changes here directly shape what caregivers see when
they clock out and how shifts bill — make them deliberately, and remember
they apply to everyone immediately. Eight sections:

## 1. Service Codes

The billable catalog. Each code: **Code**, **Name**, **Type** (which USOR
billing form it belongs to), **Rate**, **Payer Type** (VR / DSPD / PP),
**Unit Type** (Quarter-hours, Days, Sessions, or none), a **Create
Invoice** toggle (off = the code never generates invoices or low-hours
invoice requests), **Detection Keywords** (aliases that help OCR recognize
the code on uploaded paperwork), and — for VR codes — **Max Activities
Selectable** at clock-out (default 3, blank for no limit).

Codes are **archived, not deleted** — archiving retires a code from new
use without touching history, and can be undone.

## 2. Non-Service Codes

Codes for non-billable time: Admin, **Training** (special — it books
training hours automatically), Meeting, Travel, Other. Just code, name,
description.

## 3 & 4. DSPD / VR Shift Questions

The documentation questions caregivers answer at clock-out, managed per
service code (tabs).

**Adding a question**: question text, optional **guidance** (help text
shown under the question at clock-out), the **type** — Free Response,
Yes/No, Select, or Multi-Select (the last two get an options editor) —
sort order, and a **Required** switch.

Two rules to know:

- Each code is **capped by its billing form** — USOR 148 codes get 2
  questions, 95/96 codes get 3, non-USOR codes unlimited. The editor
  shows the cap and blocks adding beyond it.
- Answers flow into the client Notes timeline, the USOR forms, and
  quarterly reports — word questions the way you want them to read there.

## 5. VR Activity Lists

The options behind each VR code's "Activity Completed" picker. Per-code
tabs; drag the handle to reorder (the order saves automatically); add,
edit, archive, or delete activities. The per-shift selection cap comes
from the service code's Max Activities setting.

## 6. DSPD Low Units Emails

Per DSPD service code, choose which **admins** receive the low-units alert
emails. Save after editing.

## 7. AI Email Prompts

The per-VR-code prompt used when the system drafts an authorization
request email (the drafts you approve on the Dashboard). Each code can
have its own prompt or fall back to the generic default; the tokens
{{clientName}}, {{counselorName}}, and {{lifeSkillsCourses}} fill in
automatically. You can also save a good draft from the dashboard modal as
that code's new default. **Use Generic Default** clears a custom prompt.

## 8. Mileage Settings

The mileage policy singleton: **daily deduction** (non-transport commute
miles per day, default 30), **reimbursement rate** per mile, **pay-period
cap** in dollars, and the **manager alert threshold** (% of cap, default
80). See Payroll & Mileage for how these apply.

## A note on caution

Rates, unit types, and question changes affect billing and documentation
from the moment you save. When changing a rate mid-month, remember reports
compute from current data — coordinate with your billing run.
`,
};
